import { createProviderToken } from '@core/common-legacy';

export const {
  provide: provideManageFeaturesPromotionFlag,
  inject: injectManageFeaturesPromotionFlag,
} = createProviderToken<boolean>('manage-features-promotion-flag')();
